module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h4', [_vm._v("Site Project")]), _vm._v(" "), (_vm.isManager('project|finance')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.editState()
      }
    }
  }, [_c('i', {
    class: _vm.editing ? 'fa fa-check-circle' : 'fa fa-edit'
  })]) : _vm._e(), _vm._v(" "), (this.editing) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]) : _vm._e()], 1), _vm._v(" "), _c('el-form', {
    ref: "projectForm",
    attrs: {
      "inline": "",
      "label-position": "left",
      "model": _vm.details
    }
  }, [(_vm.isSuper()) ? _c('number-input', {
    attrs: {
      "label": "Sharer #",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.sharerNo),
      callback: function($$v) {
        _vm.$set(_vm.details, "sharerNo", $$v)
      },
      expression: "details.sharerNo"
    }
  }) : _c('number-input', {
    attrs: {
      "label": "Sharer #",
      "disabled": ""
    },
    model: {
      value: (_vm.details.sharerNo),
      callback: function($$v) {
        _vm.$set(_vm.details, "sharerNo", $$v)
      },
      expression: "details.sharerNo"
    }
  }), _vm._v(" "), _c('date-input', {
    attrs: {
      "label": "Handover",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.handover),
      callback: function($$v) {
        _vm.$set(_vm.details, "handover", $$v)
      },
      expression: "details.handover"
    }
  }), _vm._v(" "), _c('date-input', {
    attrs: {
      "label": "Commencement",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.startBilling),
      callback: function($$v) {
        _vm.$set(_vm.details, "startBilling", $$v)
      },
      expression: "details.startBilling"
    }
  }), _vm._v(" "), _c('date-input', {
    attrs: {
      "label": "On Air",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.onAir),
      callback: function($$v) {
        _vm.$set(_vm.details, "onAir", $$v)
      },
      expression: "details.onAir"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Telco ID.",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.telcoSiteId),
      callback: function($$v) {
        _vm.$set(_vm.details, "telcoSiteId", $$v)
      },
      expression: "details.telcoSiteId"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Phase",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.phase),
      callback: function($$v) {
        _vm.$set(_vm.details, "phase", $$v)
      },
      expression: "details.phase"
    }
  }), _vm._v(" "), _c('select-service-type', {
    attrs: {
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.details, "serviceType", $$v)
      },
      expression: "details.serviceType"
    }
  }), _vm._v(" "), _c('select-spectrum', {
    attrs: {
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.spectrumBand),
      callback: function($$v) {
        _vm.$set(_vm.details, "spectrumBand", $$v)
      },
      expression: "details.spectrumBand"
    }
  }), _vm._v(" "), (_vm.editing) ? _c('el-alert', {
    attrs: {
      "type": "info",
      "description": "Exclude Sharer Count means exclude from fee calculations and sharer counts in general",
      "show-icon": "",
      "closable": false,
      "effect": "dark"
    }
  }) : _vm._e(), _vm._v(" "), _c('switch-input', {
    attrs: {
      "label": "Include Share Count",
      "on-text": "Exlcude from Sharer Counts",
      "on-color": "#F56C6C",
      "on-icon": "fa fa-times-circle",
      "off-text": "Include in Sharer Counts",
      "off-color": "#67C23A",
      "off-icon": "fa fa-check-circle",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.excludeShareCount),
      callback: function($$v) {
        _vm.$set(_vm.details, "excludeShareCount", $$v)
      },
      expression: "details.excludeShareCount"
    }
  })], 1), _vm._v(" "), _c('buildings-table', {
    attrs: {
      "site-id": _vm.details.site_id,
      "site-data": _vm.siteData,
      "owner-id": _vm.details.organisation_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-030c1312"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/sharers/ProjectTab.vue
// module id = 1391
// module chunks = 0